import { render, staticRenderFns } from "./RegistrarUsuario.vue?vue&type=template&id=3a966046&scoped=true&"
import script from "./RegistrarUsuario.vue?vue&type=script&lang=js&"
export * from "./RegistrarUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a966046",
  null
  
)

export default component.exports